"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const LoadingSpinner_1 = __importStar(require("../../common/js/components/LoadingSpinner"));
const ShopCheckoutRadio = ({ additionalFields, additionalFieldsFullWidth, checked, disabled, groupName, onChange, selectableMethod, }) => {
    const [loading, setLoading] = (0, react_1.useState)(false);
    const wrappedAdditionalFields = (Array.isArray(additionalFields) ? additionalFields : [additionalFields])
        .filter((field) => !!field)
        .map((field, index) => (react_1.default.createElement("div", { key: index, className: (0, classnames_1.default)('znd-shop-checkout-radio__additional-field', {
            ['znd-shop-checkout-radio__additional-field--column']: !additionalFieldsFullWidth,
        }) }, field)));
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-shop-checkout-radio__wrapper', { ['--loading']: loading }) },
        react_1.default.createElement("label", { htmlFor: selectableMethod.id, className: (0, classnames_1.default)('znd-shop-checkout-radio', 'd-flex', 'justify-content-between', 'align-items-center') },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('d-flex', 'align-items-center', 'custom-control', 'custom-radio') },
                react_1.default.createElement("input", { className: (0, classnames_1.default)('custom-control-input', 'znd-shop-checkout-radio__input'), type: "radio", name: groupName, id: selectableMethod.id, checked: !!checked, disabled: loading || disabled, onChange: () => {
                        setLoading(true);
                        onChange(selectableMethod.id ?? '').finally(() => {
                            setLoading(false);
                        });
                    } }),
                react_1.default.createElement("span", { className: "znd-shop-checkout-radio__label custom-control-label" }, selectableMethod.translated?.name)),
            loading ? (react_1.default.createElement(LoadingSpinner_1.default, { className: "znd-shop-checkout-radio__loading ml-auto mr-auto", style: LoadingSpinner_1.LoadingSpinnerStyle.thick })) : null,
            selectableMethod.media ? (react_1.default.createElement("img", { className: "znd-shop-checkout-radio__image", alt: selectableMethod.media.alt, src: selectableMethod.media.url })) : (react_1.default.createElement("div", { className: "znd-shop-checkout-radio__image" }))),
        checked && wrappedAdditionalFields.length > 0 ? (react_1.default.createElement("div", { className: "znd-shop-checkout-radio__additional-fields" }, wrappedAdditionalFields)) : null));
};
exports.default = (0, mobx_react_1.observer)(ShopCheckoutRadio);
